import { SyntheseInventaireEspeceEdition } from './synthese-inventaire-espece-edition';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SyntheseInventaireEdition {
    static jsonMap = {
        idEntreprise: { key: 'idEntreprise' },
        campagne: { key: 'campagne' },
        dateInventaire: { key: 'dateInventaire', optional: true, default: '' },
        raisonExploitation: { key: 'raisonExploitation', optional: true, default: '' },
        raisonGp: { key: 'raisonGp', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        siret: { key: 'siret', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' },
        tva: { key: 'tva', optional: true, default: '' },
        estEcoResp: { key: 'estEcoResp', optional: true },
        estBio: { key: 'estBio', optional: true },
        syntheseInventaireEspeceEditionList: {
            key: 'syntheseInventaireEspeceEditionList',
            converter: new (ArrayClassConverterFactory.build(SyntheseInventaireEspeceEdition))(),
            optional: true
        },
        surfaceTotale: { key: 'surfaceTotale', optional: true },
        surfaceIrriguee: { key: 'surfaceIrriguee', optional: true },
        surfaceGrele: { key: 'surfaceGrele', optional: true },
        surfaceGel: { key: 'surfaceGel', optional: true },
        surfaceBio: { key: 'surfaceBio', optional: true }
    };

    idEntreprise: number;
    campagne: string;
    dateInventaire: string;
    raisonExploitation: string;
    raisonGp: string;
    adresse: string;
    commune: string;
    siret: string;
    telephone: string;
    mail: string;
    tva: string;
    estEcoResp: boolean;
    estBio: boolean;
    syntheseInventaireEspeceEditionList: SyntheseInventaireEspeceEdition[];
    surfaceTotale: number;
    surfaceIrriguee: number;
    surfaceGrele: number;
    surfaceGel: number;
    surfaceBio: number;
}
